/*******************************************************
WATCH PLAYER SEARCH INPUT
Handle keyboard events with the player search input.
********************************************************/

import buildSearchResult from './build-search-result';
import searchPlayers from './search';

export default async function triggerSearchPlayers(e) {

    // Searchable sports
    const searchableSports = ['All','MLB','NFL','NBA','EUR','NHL','PGA','RAC','CFB','CBB','SOC','MMA','DAY','MYROTOWIRE','CFL','WNB','TEN', 'XFL', 'ESP', 'CRI', 'KBO', 'CPB', 'AFL', 'NPB', 'USF', 'F1'];

    // Get the input
    const $input = $(e.currentTarget);

    // Get the search class from the input
    const searchClass = $input.data('search');

    // Get the container element
    const $searchSection = $('.'+searchClass);

    // Get the sport from the input
    let sport = $input.data('sport') || '';

    // If the sport is not searchable simply return
    if( $.inArray(sport,searchableSports) === -1 ){ return; }

    // Cast the special DAY and MYROTOWIRE cases to All
    if(sport === "DAY" || sport === "MYROTOWIRE"){ sport = "All"; }

    // Get the search term and convert to lowercase (to improve probability of using Redis cache) and remove any curly quotes (common problem with iPhones)
    const searchTerm = String($input.val() || '').toLowerCase().replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');

    // Store the last search
    const lastSearch = $input.data('lastsearch') || '';

    // If the last search is the same as the current search, don't run it again
    if (searchTerm === lastSearch || !searchTerm) { return; }

    // Add the clear button to the search box if it doesn't already exist
    const $clearButton = $('<div>', { 
        class: searchClass ? searchClass + '-clear' : '',
        id   : 'player-search-clear',
    }).html('&times;');
    if ($('#player-search-clear').length === 0) { $searchSection.append($clearButton); }

    // Add the container for the search results if it doesn't already exist
    let $searchResults = $('<ul>', {
        class: searchClass ? searchClass + '-results' : '',
        id   : 'player-search-results',
    });
    if ($('#player-search-results').length === 0) { $searchSection.append($searchResults); }

    // Grab the search results element from the page
    $searchResults = $('#player-search-results');

    // Display a message and exit out if there are fewer than 2 characters
    if (searchTerm.length < 2) {
        $searchResults.html('<li class="search-result__message">Please enter at least 2 characters.</li>');
        return;
    }

    // Empty the search results and add a "Searching..." message
    $searchResults.html('<li class="search-result__message">Searching for players...</li>');

    // Set the data that gets used with the AJAX query
    const settings = {
        searchTerm,
    };

    // If a sport was passed in, add it to the AJAX call
    if (sport) { settings.sport = sport; }

    try {
        // Store the current search term in a data attribute (useful for preventing duplicate AJAX calls)
        $input.data('lastsearch', searchTerm);

        // Search the players
        // If players is undefined, the rest of this try block won't run
        const { players } = await searchPlayers(settings);

        // If there are no results, exit out and show the empty state
        if (players.length === 0) {
            $searchResults.html('<li class="search-result__message">No players matched your search.</li>');
            return;
        }

        // Build an array of search result HTML and add the results to the container
        const searchResults = players.map(player => buildSearchResult(sport,player));
        $searchResults.safehtml(searchResults.join(''));

    }
    catch (err) {
        // Error message already handled in search.js
    }
}
